import { get } from 'lodash';

import { formatFieldName } from './utils';

const findError = (errors, fieldName) => {
  const formattedFieldName = formatFieldName(fieldName);
  return get(errors, formattedFieldName);
};

export const hasError = (errors, fieldName) => {
  if (Object.keys(errors).length === 0) {
    return false;
  }
  if (findError(errors, fieldName)) {
    return true;
  } else {
    return false;
  }
};

const getErrorMessage = (errors, fieldName) => {
  const error = findError(errors, fieldName);
  if (error) {
    return error?.message || 'Required';
  }
};

export type QuestionLibraryError = {
  hasError: boolean;
  errorMessage?: string;
};

export const getError = (errors, fieldName) => {
  return {
    hasError: hasError(errors, fieldName),
    errorMessage: getErrorMessage(errors, fieldName),
  } as QuestionLibraryError;
};
